module.exports = __webpack_public_path__ + "img/Kavish_headshot-modified.cfc5d682.png";